module.exports = __webpack_public_path__ + "img/e_shondrev.d169fa5a.jpg";